import React from "react";
import { Alert } from "@gettactic/components/src/data-display/Alert/Alert";
import { cn } from "@gettactic/helpers";

interface WPRequestErrorsProps {
  errors: string[];
  className?: string;
}

export const WPRequestErrors: React.FC<WPRequestErrorsProps> = ({
  errors,
  className
}) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <div className={cn("space-y-2", className)}>
      {errors.map((error, index) => (
        <Alert
          key={index}
          variant="error"
          canDismiss={false}
          alertTitle={error}
          alertMessage=""
          className="px-4 py-2"
        />
      ))}
    </div>
  );
};
